<script>
import request from '@/services/request'
import { mapActions } from 'vuex';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    data() {
        return {
            load: false,
            department_id: '',
            page: 1,
            errors: {},
            tenant: {
                total: 0
            },
            modify: false,
        }
    },
    methods: {
        closedModal() {
            this.$modal.hide('ListPaysTenant');
        },
        async list(page = 1) {
            this.load = true;
            let service = request;
            let search = {
                department_id: this.department_id,
                search: '',
                building_id: '',
                company_id: '',
                status: 1,
                finish: '',
                user_id: '',
                month: '',
                year: '',
                payment_period_id: [1, 2, 3, 4, 6, 7, 8, 9]
            };

            let _endpoint = '/contracts';
            try {
                let { data } = await service.list(_endpoint, page, search)
                if (data) {
                    console.log(data);
                    this.tenant = data;
                    this.load = false;
                }
            } catch (error) {
                console.log(error);
            }
        },
        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    created() {
        Event.$on("event-show-ContractsDepartamentAll", (departament) => {
            this.department_id = departament.id;
            this.list();
            this.$modal.show('ListPaysTenant');
        });
    }
}
</script>
<template>
    <modal name="ListPaysTenant" :width="'80%'" :scrollable="true" :maxHeight="300" :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Historial de contratos</h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-12">
                    <div class="table-responsive">
                        <table class="table table-bordered text-center text-sm">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Fechas</th>
                                    <th>Arrendatario</th>
                                    <th>Monto</th>
                                    <th>Servicios</th>
                                </tr>
                            </thead>
                            <tbody v-if="load">
                                <tr>
                                    <td align="center" colspan="4">
                                        <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                        <h5>Cargando</h5>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else-if="tenant.total > 0">
                                <tr v-for="(pay, index) in tenant.data" :key="index">
                                    <td>{{ pay.id }}</td>
                                    <td>
                                        {{ pay.start_date | toDateTime }} -
                                        <span v-if="pay.end_date">
                                            {{ pay.end_date | toDateTime }}
                                        </span>
                                        <span v-else>
                                            Sin fecha fin
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="pay.user">
                                            {{ pay.user.name }}
                                            {{ pay.user.last_name }}
                                        </span>
                                        <span v-else>
                                            N/A
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <!-- Renta única -->
                                        <div v-if="pay.unique_rent == 1 && pay.unique_rent_data">
                                            <span class="badge p-1 badge-success">Renta</span><br>
                                            {{ pay.unique_rent_data.subtotal | toCurrency }}
                                        </div>
                                        <div v-else-if="pay.departments">
                                            <div v-for="(department, index) in pay.departments" :key="index">
                                                <span class="badge p-1 badge-success ml-1"> Renta / Piso {{
                                                    department.level
                                                    }} / {{ department.number }}</span><br>
                                                {{ department.subtotal_rent | toCurrency }}
                                            </div>
                                        </div>

                                        <!-- Depósito único -->
                                        <div v-if="pay.unique_deposit == 1">
                                            <span class="badge p-1 badge-info">Depósito</span><br>
                                            {{ pay.deposit_amount | toCurrency }}
                                        </div>
                                        <div v-else-if="pay.departments">
                                            <div v-for="(department, index) in pay.departments" :key="index">
                                                <span class="badge p-1 badge-info ml-1">Depósito / Piso {{
                                                    department.level
                                                    }} / {{ department.number }}</span><br>
                                                {{ department.deposit | toCurrency }}
                                            </div>
                                        </div>

                                    </td>
                                    <td class="text-center">
                                        <div v-if="pay.unique_services == 1">
                                            <div v-for="(service, index) in pay.unique_services_data" :key="index"
                                                v-show="service.include_rent == false">
                                                <span class="badge p-1 badge-success" v-if="service.service">{{
                                                    service.service.name }}</span>
                                                <span class="badge p-1 badge-success" v-else>{{ service.service_name
                                                    }}</span><br>
                                                {{ service.subtotal | toCurrency }}
                                            </div>
                                        </div>
                                        <div v-else-if="pay.departments">
                                            <div v-for="(department, index) in pay.departments" :key="index">
                                                <div v-for="(service, index_service) in department.services"
                                                    :key="index_service" v-show="service.include_rent == false">
                                                    <span class="badge p-1 badge-success">
                                                        <p class="mb-1">{{ service.name }}</p>
                                                        Piso {{ department.level }} / {{ department.number }}
                                                    </span><br>
                                                    {{ service.subtotal | toCurrency }}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td align="center" colspan="4">Sin pagos.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>